import { adminAPIInstance, axiosInstance } from "./axiosInstance";

export const getAllRoles = async () => {
  try {
    const roles = (await axiosInstance.get("/admin/role")).data;

    if (roles) {
      return roles;
    }

    return [];

  } catch (error) {
    console.log(error);
  }
};

export const createRole = async (data) => {
  try {
    const roles = (await axiosInstance.post("/admin/role/create", data)).data;

    if (roles) {
      return roles;
    }

    return [];

  } catch (error) {
    console.log(error);
  }
};

export const assignRoleToUser = async (user_id, role_id) => {
  try {
    const user = (await axiosInstance.get(`/admin/role/assign/${user_id}/${role_id}`)).data;

    if (user) {
      return user;
    }

    return [];

  } catch (error) {
    throw error
  }
};
